/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: e86a911c (Thu May 21 20:23:17 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CashAmount, CashAmountFromJSON, CashAmountToJSON } from './'

/**
 * Amount due for Semester Two (calculated as half of total tuition minus any prior payments).
 * @export
 * @interface TuitionInvoiceSemesterTwoDue
 */
export interface TuitionInvoiceSemesterTwoDue {
  /**
   *
   * @type Date
   * @memberof TuitionInvoiceSemesterTwoDue
   */
  dueDate: Date
  /**
   *
   * @type CashAmount
   * @memberof TuitionInvoiceSemesterTwoDue
   */
  amount: CashAmount
}

export function TuitionInvoiceSemesterTwoDueFromJSON(
  json: any
): TuitionInvoiceSemesterTwoDue {
  return TuitionInvoiceSemesterTwoDueFromJSONTyped(json, false)
}

export function TuitionInvoiceSemesterTwoDueFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TuitionInvoiceSemesterTwoDue {
  if (json === undefined || json === null) {
    return json
  }
  return {
    dueDate: new Date(json['dueDate']),
    amount: CashAmountFromJSON(json['amount']),
  }
}

export function TuitionInvoiceSemesterTwoDueToJSON(
  value?: TuitionInvoiceSemesterTwoDue | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    dueDate: value.dueDate.toISOString().substr(0, 10),
    amount: CashAmountToJSON(value.amount),
  }
}
